<template>
    <div role="image" :class="classes" :style="style"/>
</template>
<script>
export default {
    name: 'Picture',
    props: {
        ratio: {
            type: Number,
            default: 1,
        },
        src: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: 'auto',
        },
        rounded: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: null,
        },
        zoomable: {
            type: Boolean,
            default: false,
        },
        /**
         * Zoom factor
         */
        zoom: {
            type: Number,
            default: 2,
        },
    },
    data () {
        return {
            position: null,
        };
    },
    computed: {
        style () {
            const style = {
                'padding-top': `${(100 / this.ratio).toFixed(2)}%`,
                'background-image': `url("${this.src}")`,
                'background-size': this.size,
                'background-color': this.color,
            };

            if (this.zoomable) {
                const zoom = Math.round(100 * this.zoom);
                style['background-size'] = this.position ? `${zoom}%` : '100%';
                style['background-position'] = this.position ? `${this.position.x}% ${this.position.y}%` : 'center';
            }

            return style;
        },
        classes () {
            return {
                picture: true,
                rounded: this.rounded,
            };
        },
    },
    mounted () {
        if (this.zoomable) {
            this.$el.addEventListener('mouseenter', this.setPosition);
            this.$el.addEventListener('mousemove', this.setPosition);
            this.$el.addEventListener('mouseleave', this.onMouseleave);
        }
    },
    destroyed () {
        if (this.zoomable) {
            this.$el.removeEventListener('mouseenter', this.setPosition);
            this.$el.removeEventListener('mousemove', this.setPosition);
            this.$el.removeEventListener('mouseleave', this.onMouseleave);
        }
    },
    methods: {
        setPosition (e) {
            this.position = {
                x: Math.round(100 * (e.offsetX / e.target.offsetWidth)),
                y: Math.round(100 * (e.offsetY / e.target.offsetHeight)),
            };
        },
        onMouseleave () {
            this.position = null;
        },
    },
};
</script>
<style lang="scss" scoped>
.picture {
    position: relative;
    background-repeat: no-repeat;
    background-position: center;
    transition: background-size .8s ease-in-out;

    &.rounded {
        border-radius: 12px;
        overflow: hidden;
    }
}
</style>
